export var LOGIN_TEXT = 'войти';